import React from 'react';
import ReactDOM from 'react-dom';
import classnames from 'classnames';
import Radium from 'radium';
import {assign} from 'lodash';
import PropTypes from 'prop-types';

const findParentNode = (parentClass, child) => {
  let parent = child.parentNode;
  while (parent && (parent.className === undefined || parent.className.indexOf(parentClass) === -1)) {
    parent = parent.parentNode;
  }
  return parent;
};

class Modal extends React.Component {

  constructor(props) {
    super(props);

    this.requestHide = this.requestHide.bind(this);
    this.handleBackDropClick = this.handleBackDropClick.bind(this);
    this.handleFocus = this.handleFocus.bind(this);
    this.handleBlur = this.handleBlur.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.handleBody = this.handleBody.bind(this);
    this.handleParent = this.handleParent.bind(this);
  }

  static propTypes = {
    className: PropTypes.string,
    isOpen: PropTypes.bool.isRequired,
    backdrop: PropTypes.bool,
    keyboard: PropTypes.bool,
    size: PropTypes.oneOf(['modal-lg', 'modal-sm', '']),
    onRequestHide: PropTypes.func,
    backdropStyles: PropTypes.object,
    dialogStyles: PropTypes.object,
    children: PropTypes.node.isRequired
  };

  static defaultProps = {
    isOpen: false,
    backdrop: true,
    keyboard: true,
    size: '',
    backdropStyles: {},
    dialogStyles: {}
  };

  componentDidMount () {
    document.addEventListener('keydown', this.handleKeyDown);
    this.handleBody();
    this.handleParent();
  };

  componentWillUnmount ()  {
    document.removeEventListener('keydown', this.handleKeyDown);
  };

  componentDidUpdate ()  {
    this.handleBody();
    this.handleParent();
  };

  requestHide () {
    let {onRequestHide} = this.props;
    if (onRequestHide) {
      onRequestHide();
    }
  };

  handleBackDropClick (e) {
    let {backdrop} = this.props;
    if (e.target !== e.currentTarget || !backdrop) {
      return;
    }
    this.requestHide();
  };

  handleFocus () {
    this.focus = true;
  };

  handleBlur () {
    this.focus = false;
  };

  handleKeyDown (e) {
    let {keyboard} = this.props;
    let el = ReactDOM.findDOMNode(this);
    let childrenOpen = el.className.indexOf('children-open') !== -1;
    if (keyboard && this.focus && e.keyCode === 27 && !childrenOpen) {
      e.preventDefault();
      setTimeout(this.requestHide, 0);
    }
  };

  handleBody () {
    let openModals = document.getElementsByClassName('modal-backdrop-open');
    if (openModals.length < 1) {
      document.body.className = document.body.className.replace(/ ?modal-open/, '');
    } else if (document.body.className.indexOf('modal-open') === -1) {
      document.body.className += document.body.className.length ? ' modal-open' : 'modal-open';
    }
  };

  handleParent () {
    let parentNode = findParentNode('modal-backdrop', ReactDOM.findDOMNode(this));
    if (parentNode) {
      let {isOpen} = this.props;
      if (isOpen) {
        parentNode.className += parentNode.className.length ? ' children-open' : 'children-open';
        parentNode.style.overflowY = 'hidden';
      } else {
        parentNode.className = parentNode.className.replace(/ ?children-open/, '');
        parentNode.style.overflowY = 'auto';
      }
    }
  };

  render() {
    let {className, isOpen, backdropStyles, size, dialogStyles, children} = this.props;
    let backDropClass = classnames(['modal-backdrop', className], {
      'modal-backdrop-open': isOpen
    }).trim();

    backdropStyles = assign({
      base: {
        background: 'rgba(0, 0, 0, .7)',
        opacity: 0,
        visibility: 'hidden',
        transition: 'all 0.4s',
        overflowX: 'hidden',
        overflowY: 'auto'
      },
      open: {
        opacity: 1,
        visibility: 'visible'
      }
    }, backdropStyles);

    let dialogClass = classnames(['modal-dialog', size], {
      'modal-dialog-open': isOpen
    });

    dialogStyles = assign({
      base: {
        top: -600,
        transition: 'top 0.4s'
      },
      open: {
        top: 0
      }
    }, dialogStyles);

    return (
      <div className={backDropClass} role='presentation'
        style={[backdropStyles.base, isOpen && backdropStyles.open]}
        onClick={this.handleBackDropClick}>
        <div className={dialogClass}
          style={[dialogStyles.base, isOpen && dialogStyles.open]}
          tabIndex="-1"
          onFocus={this.handleFocus}
          onBlur={this.handleBlur}>
          <div className="modal-content">{children}</div>
        </div>
      </div>
    );
  }
}

export default Radium(Modal);
